export default __webpack_public_path__ + "static/airbus-logo_logo.inline-fcd6664a699558fa0637ddbbdb400a09.png";